<div class="skeleton-product-detail-card">
  <div class="skeleton-product-detail-card__left">
    <div class="header">
      <div class="wrapper">
        <div class="skeleton skeleton--text"></div>
        <div class="skeleton skeleton--text"></div>
      </div>
      <div class="skeleton skeleton--avatar"></div>
    </div>
    <div class="skeleton skeleton--image"></div>
  </div>

  <div class="skeleton-product-detail-card__right">
    <div class="top">
      <div class="skeleton skeleton--title"></div>
      <div class="skeleton skeleton--description"></div>
      <div class="skeleton skeleton--description"></div>
    </div>

    <div class="bottom">
      <div class="skeleton skeleton--footer"></div>
      <div class="skeleton skeleton--footer short"></div>
    </div>
  </div>
</div>
